/**
 * Created by cl-macmini-34 on 24/08/17.
 */
App.factory('printNurseBadge', PrintNurseBadge);

function PrintNurseBadge() {
    var serviceObj = {};
    serviceObj.print = Print;
    function Print(data) {

        var html = '<div style="width: 204px;height: 323px;background-color: #fff;border: 1px solid #462b68;position: relative;">'+
                        '<div style="text-align:center;padding-top:10px;"><img src="'+data.hospital.facility.logoURL+'" style="width: auto;height: 42px;"></div>'+
                        '<div style="text-align:center;padding-top:10px;"><img src="'+data.nurse.profilePic+'" style="width:100px;border-radius:50%"></div>'+
                        '<div style="text-align:center;padding-top:10px;font-size:22px;color:#462b68;text-transform:capitalize;">'+data.nurse.firstName+'</div>'+
                        '<div style="text-align:center;padding-top:5px;font-size:10px;color:#9f8ea0;text-transform:capitalize;">'+data.nurse.lastName+'</div>'+
                        '<div style="text-align:center;padding-top:12px;font-size:18px;color:#462b68;">'+data.licenseType+'</div>'+
                        '<div style="text-align:center;background-color:#2e1a47;position: absolute;bottom: 0;padding: 16px 0; -webkit-print-color-adjust: exact ;width:100%;"><img src="https://assets.praoshealth.com/print-badge-footer.png"></div>'+
                    '</div>';
        teleprint({
            template: {
                html: html
            },
            inherit: {
                css: false
            }
        });
    }

    return serviceObj;
}